module.exports = __webpack_public_path__ + "img/img_thumbnail_modul.ce6d08f7.png";